<template>
  <div>
    <span v-if="label" :class="{ 'h6': !editable }">{{ label }}</span>
    <div v-if="editable" class="input-group mt-2">
      <label :for="`btn_check_${field_name}`" class="btn btn-secondary">
        <span class="fas" :class="revealed ? 'fa-eye' : 'fa-eye-slash'"></span>
      </label>
      <input type="checkbox" class="btn-check" :id="`btn_check_${field_name}`" v-model="revealed" :disabled="!value">
      <input class="form-control" :type="revealed ? 'text' : 'password'" v-model="valueCopy" :name="field_name"
        :id="field_name">
    </div>
    <div v-else class="hstack gap-2">
      <label :for="`btn_check_${field_name}`" class="btn btn-sm btn-secondary">
        <span class="fas" :class="revealed ? 'fa-eye' : 'fa-eye-slash'"></span>
      </label>
      <input type="checkbox" class="btn-check" :id="`btn_check_${field_name}`" v-model="revealed" :disabled="!value">
      <p class="text-muted m-0">{{ revealed ? value : 'Hidden' }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "RevealableInfo",
  props: {
    label: {
      type: String,
      defualt: null,
    },
    value: {
      type: String,
      default: null,
    },
    field_name: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      valueCopy: this.value,
      revealed: false,
    }
  },
  computed: {
    editable() {
      return !!this.field_name;
    },
  },
});
</script>
